function login(url) {
	const returnUrl = url || document.URL;
	location.href = `${CAFEAPP.LOGIN_URL}/accounts/loginform.do?mobilefull=1&url=${returnUrl}`;
}

export { login };
